import { render, staticRenderFns } from "./SendTestMessageModal.vue?vue&type=template&id=51e6b186&scoped=true"
import script from "./SendTestMessageModal.vue?vue&type=script&lang=js"
export * from "./SendTestMessageModal.vue?vue&type=script&lang=js"
import style0 from "./SendTestMessageModal.vue?vue&type=style&index=0&id=51e6b186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e6b186",
  null
  
)

export default component.exports